"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockVariableManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockState = require("./BlockState");
var _variables = require("@blockwell/variables");
var _reactivity = require("@vue/reactivity");
class BlockVariableManager extends _BlockState.ManagerWithState {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "dynamicVariables", []);
  }
  variableCount() {
    var _this$spec, _this$spec$vars;
    return ((_this$spec = this.spec) === null || _this$spec === void 0 ? void 0 : (_this$spec$vars = _this$spec.vars) === null || _this$spec$vars === void 0 ? void 0 : _this$spec$vars.length) || 0;
  }
  registerVariables() {
    if (!this.context) {
      throw new Error("Must have a context set before registering variables");
    }
    let vars = [...this.type.variables()];
    if (vars.length > 0) {
      // Sort first to minimize context lookups
      vars.sort((a, b) => a.context ? a.context.localeCompare(b.context) : -1);
      let ctxName = null;
      let ctx;
      for (let it of vars) {
        if (!ctx || ctxName !== it.context) {
          ctxName = it.context;
          ctx = this.context.findContext(ctxName);
        }
        ctx.addVariable(this.key, it.name, it.ref, `owner=${this.key}; block=${this.type.type}; var=${it.ref.variableType}; index=${it.ref.index}`);
        this.block.variableAdded(it);
      }
    }
  }
  addVariables() {
    if (this.dynamicVariables.length > 0) {
      throw new Error("Can't add variables, existing dynamic variables found");
    }
    this.dynamicVariables = this.spec.vars.map((it, index) => this.addVariable((0, _reactivity.reactive)(it), false));
  }
  addVariable(variable, addToSpec = true) {
    let migrated = false;
    if (addToSpec) {
      this.spec.vars.push(variable);
      // Get value for reactivity
      variable = this.spec.vars[this.spec.vars.length - 1];

      // This block doesn't have its own context yet, so create it
      migrated = this.block.ensureContext();
    }
    let ref = new _variables.VariableReference(this.registry.variableTypes.get(variable.type), variable.param);
    this.context.addVariable(this.key, variable.name, ref, `blockManager addToSpec=${addToSpec}`);
    if (addToSpec) {
      this.dynamicVariables.push(ref);
      this.registry.change({
        type: "variable",
        op: "add",
        key: ref.index
      });
    }
    if (migrated) {
      this.block.renderTree();
    }
    return ref;
  }
  updateVariable(index, variable) {
    let old = this.spec.vars[index];
    let oldCtx = this.context.findContext(old.ctx);
    let ref = this.dynamicVariables[index];
    if (ref.type.type === variable.type && old.name === variable.name && old.ctx === variable.ctx) {
      let oldName;
      if (old.type === "collection") {
        var _old$param;
        oldName = (_old$param = old.param) === null || _old$param === void 0 ? void 0 : _old$param.name;
      } else if (old.type === "collection-item") {
        var _old$param2;
        oldName = (_old$param2 = old.param) === null || _old$param2 === void 0 ? void 0 : _old$param2.collection;
      }
      ref.updateAllParameters(variable.param);
      if (old.type === "collection") {
        oldCtx.updateCollectionName(ref, oldName, variable.param.name);
      } else if (old.type === "collection-item") {
        oldCtx.updateCollectionName(ref, oldName, variable.param.collection);
      }
      this.registry.change({
        type: "variable",
        op: "update",
        key: ref.index
      });
      return ref;
    } else {
      let listeners = ref.events.migrateFrom();
      oldCtx.removeVariable(ref);
      this.spec.vars.splice(index, 1, variable);
      // read from vars to include reactivity
      variable = this.spec.vars[index];
      let newRef = this.addVariable(variable, false);
      this.dynamicVariables.splice(index, 1, newRef);
      newRef.events.migrateTo(listeners);
      this.block.specUpdated();
      this.registry.change({
        type: "variable",
        op: "replace",
        key: newRef.index
      });
      return newRef;
    }
  }
  removeVariable(index) {
    let old = this.spec.vars[index];
    let ctx = this.context.findContext(old.ctx);
    let ref = this.dynamicVariables[index];
    ctx.removeVariable(ref);
    this.spec.vars.splice(index, 1);
    this.dynamicVariables.splice(index, 1);
    this.block.specUpdated();
    this.registry.change({
      type: "variable",
      op: "remove",
      key: ref.index
    });
  }
  variableInstance(index) {
    return this.dynamicVariables[index];
  }
  updateParameter(key, value, oldValue) {
    let specUpdated = false;
    for (let it of this.type.blockVariables) {
      if (it.keys) {
        let mapping = it.keys.find(it => Array.isArray(it) ? it[0] === key : it === key);
        if (mapping && it.ref instanceof _variables.VariableReference) {
          if (it.nameKey === key && (0, _variables.isVariableConfig)(value)) {
            let ctx = this.context.findContext(it.context);
            ctx.removeVariable(it.ref);
            it.name = value.name;
            if (value.ctx) {
              ctx = this.context.findContext(value.ctx);
            }
            ctx.addVariable(this.key, value.name, it.ref, `owner=${this.key}; block=${this.type.type}; var=${it.ref.variableType}; index=${it.ref.index}`);
            specUpdated = true;
          } else {
            let useKey = Array.isArray(mapping) ? mapping[1] : mapping;
            if (it.ref.type instanceof _variables.CollectionItemVariable && useKey === "collection" || it.ref.type instanceof _variables.CollectionVariable && useKey === "name") {
              let ctx = this.context.findContext(it.context);
              ctx.updateCollectionName(it.ref, oldValue, value);
              specUpdated = true;
            } else {
              it.ref.updateParameter(useKey, value);
            }
          }
        }
      }
    }
  }
}
exports.BlockVariableManager = BlockVariableManager;
//# sourceMappingURL=BlockVariableManager.js.map